<template>
    <div class="center">
      <vs-dialog v-model="active" prevent-close>
        <template #header>
          <h4 class="not-margin">
            ¿Esta seguro de eliminar la configuración?
          </h4>
        </template>
        <div class="con-form">
          La configuración se eliminara permanentemente.
        </div>
        <template #footer>
          <div class="footer-dialog">
            <vs-row>
                  <vs-col lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false"
                        style="width: 95%"
                    >
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col lg="6">
                    <vs-button
                        success
                        @click="getEliminarConfiguracion()"
                        style="width: 95%"
                        class="ml-auto"
                    >
                        Aceptar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
    import academico from '../../../../../api/requests/academico.js'
    export default {
        props:[
            'value',
            'row'
        ],
      data:() => ({
        active: false,
        calificacion: '',
        faltas: '',
        retardos: '',
        fecha_inicio_periodo: '',
        fecha_fin_periodo: '',
        fecha_inicio_captura: '',
        hora_inicio_captura: '',
        fecha_fin_captura: '',
        hora_fin_captura: '',
        conducta: '',
        tareas_no_hechas: '',
        activo_boleta: '',
        mostrar_acta: ''
      }),
      methods:{
        async getEliminarConfiguracion(){
          try{
                const loading = this.$vs.loading()
              const formData = new FormData();
              formData.append('calificacion', this.row.detalle_componente_id)
              const response = await academico.getEliminarConfiguracion(this.row.id)
              loading.close()
              this.active = false
              this.$emit('refreshTable',true)
              this.$vs.notification({
                  progress: 'auto',
                  color: 'success',
                  position: null,
                  title: 'Operación éxitosa',
                  text: 'Se ha eliminado la información correctamente'
              })
          }catch{
                loading.close()
          }
        }
      },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
    }
</script>

<style>
label{
    margin-bottom: 0;
}
</style>
